import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";

import { TextTitlePage } from "./styles";
import { Container, Content, TextFieldLogin, Button, BottomSheet, Header, CustomDropDown, TextField } from "../../components";
import TabsAdmin from "../../navigation/tab";
import { TextInput } from "react-native-paper";
import { api } from "../../api/api";
import { Modalize } from "react-native-modalize";
import UserContext from "../../context/user";
import ClientContext from "../../context/client";
import RegisterDriverContext from "../../context/registerDriver";
import RouteContext from "../../context/route";

const ChangePassword = () => {
  const navigation = useNavigation();
  const bottomSheetErrorRef = useRef<Modalize>(null);
  const { user, changePassword } = useContext(UserContext);
  
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleChangePassword() {
    setLoading(true);
    const data = { password };
    try {
      await changePassword(data);
      setLoading(false);
      navigation.navigate('Loading');
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }

  return (
    <Container>
      <Header changePassword name={user.name} />
      <Content>
        <TextTitlePage>Atualize sua senha</TextTitlePage>
        <TextField
          label="Senha"
          placeholder="Digite sua senha"
          value={password}
          onChangeText={(text: string) => setPassword(text)}
        /> 
        <Button title='Atualizar' onPress={handleChangePassword} />
      </Content>
    </Container>
  );
};

export default ChangePassword;
